import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormCreateCustomMakeActionParams {
  form: UseFormReturn<BaseVehicle>;
  customMake: string;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for creating a custom vehicle make
 * Only handles setting custom make values - field resets are handled separately
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and custom make value
 */
export const formCreateCustomMakeAction = (
  _context: unknown,
  params: FormCreateCustomMakeActionParams
): void => {
  const {form, customMake} = params;

  form.setValue('customMake', customMake);
  form.setValue('formMake', customMake);
  form.setValue('make', customMake, DEFAULT_OPTIONS);

  form.setValue('unknownModels', [
    {
      label: i18n.t('entity.vehicle.labels.otherLabel'),
      value: i18n.t('entity.vehicle.labels.otherLabel'),
    },
  ]);

  // Add to unknown makes for UI state
  const currentUnknownMakes = form.getValues('unknownMakes') ?? [];
  const newMakeOption = {value: customMake, label: customMake};

  if (!currentUnknownMakes.some((make) => make.value === customMake)) {
    form.setValue('unknownMakes', [...currentUnknownMakes, newMakeOption]);
  }
};
